

























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as JobsAPI from '@/api/jobsApi';
import { vxm } from '@/stores';

@Component({})
export default class EmailTake5 extends Vue {
  @Prop({ type: String, default: null }) public formID!: string;
  @Prop({ type: String, default: null }) public emailAddress!: string;
  @Prop({ type: Boolean, default: false}) public showSendEmail: boolean;
  private emailLoading: boolean = false;
  private emailErrorMessage: string = '';
  private editedEmailAddress: string = '';
  textRequired(v: string) {
    if(v == null || v.length == 0){
      return "Cannot be left blank";
    }

    return true;
  }

  emailRule(v: string) {
    if(!/.+@.+/.test(v)) {
      return "Email is not valid.";
    }
    return true;
  }

  @Watch('showSendEmail')
  onShowSendEmail() {
    this.editedEmailAddress = this.emailAddress;
  }

  close(){
    this.$emit("onClose");
  }

  async emailTake5Form(){
    let form: any = this.$refs.emailForm;
    if(!form.validate()){
      return;
    }
    this.emailLoading = true;

    try {
      await JobsAPI.emailTake5Form(this.formID, this.editedEmailAddress);

      vxm.navigation.showSnackbar({
        message: 'Email Sent', 
        timeout: 3000,
        color: 'success'
      });

      this.close();
    } catch (err){
      this.emailErrorMessage = err;
    }

    this.emailLoading = false;
  }

  created() {
    this.editedEmailAddress = this.emailAddress;
  }
}

